import { sendAppcuesEvent } from "@/services/util.service";

const craneSessionTimer = import.meta.env.VITE_APP_CRANE_SESSION_TIMER;

export const sessionTimer = {
    namespaced: true,
    state: {
        startTime: null,
        timerId: null,
    },
    mutations: {
        setStartTime(state, timestamp) {
            state.startTime = timestamp;
        },
        setTimerId(state, id) {
            state.timerId = id;
        },
        clearTimer(state) {
            if (state.timerId) clearInterval(state.timerId); // stop timer if running
            state.timerId = null; // reset to null
        },
    },
    actions: {
        initSession({ commit, dispatch }) {
            try {
                let stored = localStorage.getItem(craneSessionTimer);
                let now = Date.now();
                if (stored) {
                    const savedTime = parseInt(stored, 10);
                    commit("setStartTime", savedTime);
                } else {
                    localStorage.setItem(craneSessionTimer, now);
                    commit("setStartTime", now);
                }
                dispatch("startTimer");
            } catch (error) {
                console.error("Error in init Timer:", error);
            }
        },
        startTimer({ state, commit, rootState }) {
            try {
                if (state.timerId) return;

                const id = setInterval(() => {
                    if (!state.startTime) return;

                    const diffMs = Date.now() - state.startTime;
                    const diffMinutes = Math.floor(diffMs / (1000 * 60));
                    sendAppcuesEvent("minutes_spent", {
                        minutes: diffMinutes,
                        session_id: rootState.sessionOne?.one?.id,
                        sku: rootState.sessionOne?.one?.productData?.sku,
                        product_name: rootState.sessionOne?.one?.productData?.productName,
                        product_quantity: rootState.sessionOne?.one?.productData?.quantity,
                    })
                }, 300 * 1000);

                commit("setTimerId", id);
            } catch (error) {
                console.error("Error in startTimer:", error);
            }
        },
        stopSession({ commit }) {
            commit("clearTimer");
            localStorage.removeItem(craneSessionTimer);
        },
    },
};
